import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceRoutineDetailModel } from 'src/app/models/maintenance/maintenance-routine-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MaintenanceRoutineDetailTableModel } from 'src/app/models/tables/maintenance/maintenance-routine-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceRoutineDetailService {

  constructor(private _httpClient: HttpClient) { }

  createMultipleDetailsAsync(listActivities: number[], maintenancRoutineId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.CreateMultipleDetailsAsync}/${maintenancRoutineId}`,
      listActivities);
  }

  deleteDetail(maintenancRoutineDetailId: number): Observable<MaintenanceRoutineDetailModel> {
    return this._httpClient.delete<MaintenanceRoutineDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.DeleteAsync}/${maintenancRoutineDetailId}`);
  }

  deleteSomeDetails(elementIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.DeleteSomeDetailsAsync}`,
      elementIds);
  }

  getAllElementWithPaginationAsync(maintenanceRoutineId: number, elementId: number, page: number, limit: number, columnSort: string | null,
    ascendant: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant)
      .set('maintenanceRoutineId', maintenanceRoutineId).set('elementId', elementId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.GetAllMaintenanceRoutineDetailsWithPaginationAsync}`,
      { params: params }
    );
  }

  getMaintenanceActivitiesForSelectionAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], elementId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('elementId', elementId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.GetMaintenanceActivitiesForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getMaintenanceRoutineDetailsByElementIdAsync(maintenanceRoutineId: number, elementId: number): Observable<MaintenanceRoutineDetailTableModel[]> {
    return this._httpClient.get<MaintenanceRoutineDetailTableModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.GetMaintenanceRoutineDetailsByElementIdAsync}/${maintenanceRoutineId}/${elementId}`);
  }

  getMaintenanceRoutineDetailById(id: number): Observable<MaintenanceRoutineDetailModel> {
    return this._httpClient.get<MaintenanceRoutineDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.GetByIdAsync}/${id}`);
  }

  getColumnsAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.GetColumnsAsync}`);
  }

  getColumnsForActivitiesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.GetColumnsForActivitiesAsync}`);
  }

  updateAsync(maintenancRoutineDetailId: number, maintenancePlan: number): Observable<MaintenanceRoutineDetailModel> {
    return this._httpClient.get<MaintenanceRoutineDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineDetail.UpdateAsync}/${maintenancRoutineDetailId}/${maintenancePlan}`
    );
  }
}
